import * as React from 'react';

import {
  List,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  ReferenceField,
  Datagrid,
  TextField,
  DateField,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
  DateInput,
  FunctionField,
  required,
} from 'react-admin';

export const RepDistributorList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField label="Rep" source="repId" reference="reps">
        <FunctionField
          render={(rep) => `${rep.firstName} ${rep.lastName} (${rep.email})`}
        />
      </ReferenceField>
      <ReferenceField
        label="Distributor"
        source="distributorId"
        reference="distributors"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
    </Datagrid>
  </List>
);

export const RepDistributorCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <BooleanInput source="active" />
      <BooleanInput source="admin" />
      <DateInput source="fromDate" />
      <DateInput source="toDate" />
      <ReferenceInput
        label="Distributor"
        source="distributorId"
        reference="distributors"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Rep"
        source="repId"
        reference="reps"
        filterToQuery={(searchText) => ({ lastName: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="lastName" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const RepDistributorEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <BooleanInput source="active" />
      <BooleanInput source="admin" />
      <DateInput source="fromDate" />
      <DateInput source="toDate" />
      <ReferenceInput
        label="Distributor"
        source="distributorId"
        reference="distributors"
        filterToQuery={(searchText) => ({ name: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput
        label="Rep"
        source="repId"
        reference="reps"
        filterToQuery={(searchText) => ({ lastName: searchText })}
        validate={required()}
      >
        <AutocompleteInput optionText="lastName" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
